import { DateTime } from "luxon";
import * as Yup from "yup";

import { dateValidation } from "../RequirementsAndActivityTab/utils/requirementsSchema";

export interface ProcessDateSearch {
  processDate?: string;
}

const DISPLAY_DATE_FORMAT = "MM/dd/yyyy";

const dateShort = (date: string): DateTime =>
  DateTime.fromFormat(date, DISPLAY_DATE_FORMAT);

const twoYearsAgo = new Date();
twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2);

export const processDateSchema: Yup.SchemaOf<ProcessDateSearch> =
  Yup.object().shape({
    processDate: dateValidation()
      .test("notFutureDate", "Cannot be future date", date => {
        if (!date) return true;
        return dateShort(date) < DateTime.now();
      })
      .test(
        "moreThanTwoYearsInThePast",
        "Cannot be more than two years in the past",
        date => {
          if (!date) return true;
          return dateShort(date) > DateTime.fromJSDate(twoYearsAgo);
        }
      ),
  });
